import { createPortal as createPortalDOM } from 'react-dom';
export const createPortal = createPortalDOM;
//# sourceMappingURL=index.web.js.map